import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import App from './containers/App'
import reportWebVitals from './reportWebVitals'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './styles/_index.scss'
import { SessionWarningProvider } from './context/SessionWarning'

const root = ReactDOM.createRoot(
  document.getElementById('redfunnel__consumer-booking'),
)
root.render(
  <Provider store={store}>
    <SessionWarningProvider>
      <Router basename={process.env.REACT_APP_BASE_PATH}>
        <App />
      </Router>
    </SessionWarningProvider>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
